"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLiquidPixelVisualizerWrapper = exports.StyledLiquidPixelVisualizerRatioBox = exports.StyledLiquidPixelVisualizer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _RatioBox = _interopRequireDefault(require("../RatioBox/RatioBox.index"));

var _templateObject, _templateObject2, _templateObject3;

var StyledLiquidPixelVisualizer = _styledComponents["default"].section.withConfig({
  displayName: "LiquidPixelVisualizerstyles__StyledLiquidPixelVisualizer",
  componentId: "sc-sd7na7-0"
})(["height:fit-content;"]);

exports.StyledLiquidPixelVisualizer = StyledLiquidPixelVisualizer;
var StyledLiquidPixelVisualizerRatioBox = (0, _styledComponents["default"])(_RatioBox["default"]).withConfig({
  displayName: "LiquidPixelVisualizerstyles__StyledLiquidPixelVisualizerRatioBox",
  componentId: "sc-sd7na7-1"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["br2-l shadow-1-ns h-100 flex flex-wrap flex-row flex-column-ns items-center justify-center tc overflow-hidden static"]))));
exports.StyledLiquidPixelVisualizerRatioBox = StyledLiquidPixelVisualizerRatioBox;

var StyledLiquidPixelVisualizerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LiquidPixelVisualizerstyles__StyledLiquidPixelVisualizerWrapper",
  componentId: "sc-sd7na7-2"
})(["", " & > div{", ";}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["w-100 h-100 flex flex-wrap flex-row flex-column-ns items-center justify-center tc overflow-hidden"]))), (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["w-100 h-100"]))));

exports.StyledLiquidPixelVisualizerWrapper = StyledLiquidPixelVisualizerWrapper;